module.exports = __webpack_public_path__ + "img/red_packet.3669b618.svg";